/**
 * Theme toggle component - Dark mode switcher
 */

import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('theme-toggle')
export class ThemeToggle extends LitElement {
  static styles = css`
    :host {
      display: inline-block;
    }

    button {
      padding: 0.25rem 0.5rem;
      background-color: transparent;
      border: 1px solid var(--color-border);
      border-radius: 0;
      cursor: pointer;
      transition: none;
      font-size: 0.75rem;
      color: var(--text-secondary);
    }

    button:hover {
      background-color: var(--bg-tertiary);
    }
  `;

  @property({ type: Boolean }) darkMode = false;

  private handleToggle() {
    this.dispatchEvent(new CustomEvent('toggle', { bubbles: true, composed: true }));
  }

  render() {
    return html`
      <button
        @click=${this.handleToggle}
        aria-label="Toggle dark mode"
      >
        ${this.darkMode ? 'light' : 'dark'}
      </button>
    `;
  }
}
